
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C114.417 0 0 114.417 0 256c0 141.584 114.417 256 256 256 141.584 0 256-114.416 256-256C512 114.417 397.584 0 256 0zm0 480.334C132.872 480.334 31.666 380.229 31.666 256S131.771 31.666 256 31.666 480.334 131.771 480.334 256c0 123.128-100.105 224.334-224.334 224.334zm-18.989-217.363H128.003v32.039h141.003V93.014H237.01v169.957z"}})])
          )
        }
      }
    